// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes _1bb7h6k0 {
  to {
    transform: rotate(360deg);
  }
}
._1bb7h6k1 {
  display: inline-block;
  width: 34px;
  height: 34px;
  border: 3px solid rgba(255,255,255,.3);
  border-top-color: white;
  border-radius: 50%;
  animation: _1bb7h6k0 1s ease-in-out infinite;
}
._1bb7h6k2 {
  width: 20px;
  height: 20px;
}
._1bb7h6k3 {
  width: 34px;
  height: 34px;
}
._1bb7h6k4 {
  width: 46px;
  height: 46px;
}
._1bb7h6k5 {
  width: 60px;
  height: 60px;
}
._1bb7h6k6 {
  border: 3px solid rgba(255,255,255,.3);
  border-top-color: white;
}
._1bb7h6k7 {
  border: 3px solid rgba(255,255,255,.3);
  border-top-color: var(--_18w76bw2w);
}
._1bb7h6k8 {
  border: 3px solid rgba(255,255,255,.3);
  border-top-color: var(--_18w76bw2y);
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,uBAAuB;EACvB,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,sCAAsC;EACtC,uBAAuB;AACzB;AACA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;AACA;EACE,sCAAsC;EACtC,mCAAmC;AACrC","sourcesContent":["@keyframes _1bb7h6k0 {\n  to {\n    transform: rotate(360deg);\n  }\n}\n._1bb7h6k1 {\n  display: inline-block;\n  width: 34px;\n  height: 34px;\n  border: 3px solid rgba(255,255,255,.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: _1bb7h6k0 1s ease-in-out infinite;\n}\n._1bb7h6k2 {\n  width: 20px;\n  height: 20px;\n}\n._1bb7h6k3 {\n  width: 34px;\n  height: 34px;\n}\n._1bb7h6k4 {\n  width: 46px;\n  height: 46px;\n}\n._1bb7h6k5 {\n  width: 60px;\n  height: 60px;\n}\n._1bb7h6k6 {\n  border: 3px solid rgba(255,255,255,.3);\n  border-top-color: white;\n}\n._1bb7h6k7 {\n  border: 3px solid rgba(255,255,255,.3);\n  border-top-color: var(--_18w76bw2w);\n}\n._1bb7h6k8 {\n  border: 3px solid rgba(255,255,255,.3);\n  border-top-color: var(--_18w76bw2y);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
